import { MessagesKeys, useTranslate } from '@repo/shared/hooks'
import {
  Button,
  InputNumber,
  Modal,
  ModalClose,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@repo/ui/components'
import { Slider } from '@repo/ui/components/slider/slider'
import { useState } from 'react'

interface PriceDrawerProps {
  open: boolean
  min?: number
  max?: number
  onChange: (min?: number, max?: number) => void
  onClose: () => void
}

const SLIDER_MIN = 0
const SLIDER_MAX = 100_000
const SLIDER_STEP = 1000

export const PriceDrawer = ({
  open,
  min,
  max,
  onChange,
  onClose,
}: PriceDrawerProps) => {
  const { t } = useTranslate()

  const [localRange, setLocalRange] = useState<[number, number]>([
    Number.isFinite(min) ? (min as number) : SLIDER_MIN,
    Number.isFinite(max) ? (max as number) : SLIDER_MAX,
  ])
  const [localMin, setLocalMin] = useState<string>(
    typeof min === 'number' ? String(min) : '',
  )
  const [localMax, setLocalMax] = useState<string>(
    typeof max === 'number' ? String(max) : '',
  )

  const handleSliderChange = (vals: number[]) => {
    setLocalRange([vals[0] ?? SLIDER_MIN, vals[1] ?? SLIDER_MAX])
    setLocalMin(vals[0] === SLIDER_MIN ? '' : String(vals[0]))
    setLocalMax(vals[1] === SLIDER_MAX ? '' : String(vals[1]))
  }

  const handleMinInput = (val: string) => {
    setLocalMin(val)
    const num = Number(val)
    setLocalRange([val === '' ? SLIDER_MIN : num, localRange[1]])
  }
  const handleMaxInput = (val: string) => {
    setLocalMax(val)
    const num = Number(val)
    setLocalRange([localRange[0], val === '' ? SLIDER_MAX : num])
  }

  const handleApply = () => {
    onChange(
      localMin ? Number(localMin) : undefined,
      localMax ? Number(localMax) : undefined,
    )
    onClose()
  }

  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className='text-center'>
            {t('filters_price' as MessagesKeys)}
          </ModalTitle>
          <ModalClose />
        </ModalHeader>
        <div className='flex sm:max-h-[500px] overflow-y-auto flex-col gap-lg p-md'>
          <Slider
            min={SLIDER_MIN}
            max={SLIDER_MAX}
            step={SLIDER_STEP}
            value={localRange}
            onValueChange={handleSliderChange}
            color='base'
            className='mb-lg'
          />
          <div className='flex gap-md'>
            <InputNumber
              placeholder={t('filters_price_min' as MessagesKeys)}
              value={localMin}
              thousandSeparator={true}
              // onChange={(e) => handleMinInput(e.target.value)}
              onValueChange={(e) => handleMinInput(e.value)}
            />

            <span className='flex items-center justify-center'>
              {t('filters_price_to' as MessagesKeys)}
            </span>
            <InputNumber
              placeholder={t('filters_price_max' as MessagesKeys)}
              value={localMax}
              thousandSeparator={true}
              // onChange={(e) => handleMaxInput(e.target.value)}
              onValueChange={(e) => handleMaxInput(e.value)}
            />
          </div>
        </div>
        <ModalFooter>
          <Button onClick={handleApply} className='w-full' variant='fill'>
            {t('filters_apply')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
